import { render, staticRenderFns } from "./Func1Inbox.vue?vue&type=template&id=3cde8c09"
import script from "./Func1Inbox.vue?vue&type=script&lang=js"
export * from "./Func1Inbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports